import SelectBaseSmall from "~/components/SelectBase/small";

const SelectSmall = SelectBaseSmall;

export default SelectSmall;